import React, { useState, useEffect } from "react";
import { KeyValue } from "../../common/models";
import orgDataService from "services/orgDataService";
import { CardContent, CardHeader, FormControl, InputLabel, MenuItem, Select, Skeleton, TextField, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import hubsService from "services/hubsService";
import MDButton from "components/MDButton";
import { Card, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import { toast } from "react-toastify";

const HubDetailsCard = ({ hub,setIsEdit, isLoading}) => {
  const [dispatchProcsses, setDispatchProcesses] = useState<KeyValue[]>([]);
  const [shiftDataSources, setShiftDataSources] = useState<KeyValue[]>([]);
  const [locationServiceTypes, setLocationServiceTypes] = useState<KeyValue[]>([]);

  useEffect(() => {
    orgDataService.getShiftDataSources().then((data) => setShiftDataSources(data));
    orgDataService.getDispatchProcesses().then((result) => setDispatchProcesses(result));
    orgDataService.getLocationServiceTypes().then((result) => setLocationServiceTypes(result));
  }, []);

  const edit = () => {
        setIsEdit(true);
  };

  return (
    <>
      {(isLoading) ? <Skeleton variant="rectangular" width="98%" height="400px" sx={{ mx: 1, borderRadius: 3 }} ></Skeleton>: (
        <Card>
          <CardHeader title="Details"></CardHeader>
          <CardContent>
            <MDBox pb={3} px={3}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6} sx={{ mt: 2 }}>
                  <InputLabel shrink>Fuel Card Account Number</InputLabel>
                  <Typography variant="body2">{hub.fuelCardAccountNumber || "-"}</Typography>
                </Grid>
                <Grid item xs={12} md={6} sx={{ mt: 2 }}>
                  <InputLabel shrink>Group Email</InputLabel>
                  <Typography variant="body2">{hub.groupEmail || "-"}</Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel shrink>Hub Dispatch Method</InputLabel>
                  <Typography variant="body2">
                    {dispatchProcsses.find(h => h.id === hub.dispatchProcessId)?.name || "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel shrink>Shift Data Source</InputLabel>
                  <Typography variant="body2">
                    {shiftDataSources.find(s => s.id === hub.shiftDataSourceId)?.name || "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel shrink>Erail Company Account Id</InputLabel>
                  <Typography variant="body2">{hub.hubErail?.erailCompanyAccountId || "-"}</Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel shrink>Erail MVR SKU</InputLabel>
                  <Typography variant="body2">{hub.hubErail?.erailMvrSku || "-"}</Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel shrink>Erail Bgreport SKU</InputLabel>
                  <Typography variant="body2">{hub.hubErail?.erailBgreportSku || "-"}</Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel shrink>Erail Programs</InputLabel>
                  <Typography variant="body2">{hub.hubErail?.erailPrograms || "-"}</Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel shrink>Location Service Type</InputLabel>
                  <Typography variant="body2">
                    {locationServiceTypes.find(s => s.id === hub.locationServiceTypeId)?.name || "-"}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputLabel shrink>RCX Loc Id</InputLabel>
                  <Typography variant="body2">{hub.rcxLocId || "-"}</Typography>
                </Grid>
                <Grid item xs={12} justifyItems="space-between">
                  <Grid container spacing={2}>
                    <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                      <MDButton variant="contained" color="dark" onClick={edit}>
                       Edit
                      </MDButton>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </MDBox>
          </CardContent>
        </Card>
      )}
    </>
  );
};

export default HubDetailsCard;
